// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"PW-z","categoryName":"QW-z","categoryImage":"RW-z","categoryContent":"SW-z","bottomAligned":"TW-z"};